import { Child } from '@tadpoles/common'
import type { Static } from 'typebox'
import { Value } from 'typebox/value'

import type {
    MappedPersistenceCollectionDefinition,
    PersistenceCollection
} from '@tadpoles/persistence'

export type ChildRecord = Static<typeof Child>
export type FamilyChildStore = PersistenceCollection<ChildRecord, 'key'>

export const ChildCollectionDefinition: MappedPersistenceCollectionDefinition<
    typeof Child,
    ChildRecord,
    'key'
> = {
    kind: 'child',
    scope: 'user',
    primaryKey: 'key',
    modelSchema: Child,
    encode: (value) => Value.Decode(Child, value),
    decode: (value) => Value.Encode(Child, value)
}
